import 'react-quill/dist/quill.snow.css'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './App.css'
import './assets/css/style.css'

import { AuthProvider } from './context/AuthContext'
import { ToastContextProvider } from './context/ToastContext'
import Home from './pages/Home'
import Login from './pages/Login'
import Merchant from './pages/merchants/Merchant'
import Offers from './pages/offers_manager/Offers'
import Operator from './pages/operators/Operator'
import Settings from './pages/settings/Settings'
import CurrencyExchange from './pages/settings_currency/CurrencyExchange'
import SettingsCurrency from './pages/settings_currency/SettingsCurrency'
import SubAdmin from './pages/sub_admin/SubAdmin'
import TransactionManager from './pages/transaction_manager/TransactionManager'
import User from './pages/users/User'
import AuthorizationRoute from './utils/AuthorizationRoute'

import NotFound from 'pages/NotFound'
import Aml from 'pages/aml/aml'
import ChangePassword from 'pages/auth/ChangePassword'
import ForgotPassword from 'pages/auth/ForgotPassword'
import ResetPassword from 'pages/auth/ResetPassword'
import Category from 'pages/category_manager/Category'
import EarningManager from 'pages/earning_manager/EarningManager'
import LogsManagement from 'pages/logs_management/LogsManagement'
import ManageMicroCredit from 'pages/manage_micro_credit/ManageMicroCredit'
import ManageMicroCreditLoanSlabs from 'pages/manage_micro_credit_loan_slabs/ManageMicroCreditLoanSlabs'
import ManageOrders from 'pages/manage_orders/ManageOrders'
import MicroCreditRequestSetting from 'pages/micro_credit_request_setting/MicroCreditRequestSetting'
import Profile from 'pages/profile/Profile'
import SubCategory from 'pages/subcategory_manager/SubCategory'
import WalletWindow from 'pages/wallet_window/WalletWindow'
import ProtectedRoute from 'utils/ProtectedRoute'
import SharedLayout from 'utils/SharedLayout'
import AboutUs from './pages/static_content/AboutUs'
import Careers from './pages/static_content/Careers'
import ContactUs from './pages/static_content/ContactUs'
import Faq from './pages/static_content/FAQ'
import PrivatePolicy from './pages/static_content/PrivatePolicy'
import TermsAndConditions from './pages/static_content/TermsAndConditions'

function App () {
  return (
    <BrowserRouter>
      <ToastContextProvider>
        <AuthProvider>
          <Routes>
            <Route element={<SharedLayout />}>
              {/* <Route
                exact
                path="/"
                element={
                  <ProtectedRoute>
                  </ProtectedRoute>
                }
              ></Route> */}

              <Route exact path='/dashboard' element={<Home />} />

              <Route
                exact
                path='/users'
                element={
                  <AuthorizationRoute>
                    <User />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/sub-admin-manager'
                element={
                  <AuthorizationRoute>
                    <SubAdmin />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/static/faqs'
                element={
                  <AuthorizationRoute>
                    <Faq />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/static/careers'
                element={
                  <AuthorizationRoute>
                    <Careers />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/static/about-us'
                element={
                  <AuthorizationRoute>
                    <AboutUs />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/static/contact-us'
                element={
                  <AuthorizationRoute>
                    <ContactUs />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/static/terms-and-conditions'
                element={
                  <AuthorizationRoute>
                    <TermsAndConditions />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/static/privacy-policy'
                element={
                  <AuthorizationRoute>
                    <PrivatePolicy />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/merchants'
                element={
                  <AuthorizationRoute>
                    <Merchant />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/operators'
                element={
                  <AuthorizationRoute>
                    <Operator />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/settings'
                element={
                  <AuthorizationRoute>
                    <Settings />
                  </AuthorizationRoute>
                }
              />

               <Route
                exact
                path='/currency-settings'
                element={
                  <AuthorizationRoute>
                    <SettingsCurrency />
                  </AuthorizationRoute>
                }
              />

               <Route
                exact
                path='/currency-exchange'
                element={
                  <AuthorizationRoute>
                    <CurrencyExchange />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/transaction-manager'
                element={
                  <AuthorizationRoute>
                    <TransactionManager />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/categories'
                element={
                  <AuthorizationRoute>
                    <Category />
                  </AuthorizationRoute>
                }
                // name='Category manager'
              />

              <Route
                exact
                path='/subCategories'
                element={
                  <AuthorizationRoute>
                    <SubCategory />
                  </AuthorizationRoute>
                }
                // name='Subcategory manager'
              />

              <Route
                exact
                path='/profile'
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />

              <Route
                exact
                path='/offers'
                element={
                  <AuthorizationRoute>
                    <Offers />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/earning-managers'
                element={
                  <AuthorizationRoute>
                    <EarningManager />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/categories'
                element={
                  <AuthorizationRoute>
                    <Category />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/subCategories'
                element={
                  <AuthorizationRoute>
                    <SubCategory />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/logs-management'
                element={
                  <AuthorizationRoute>
                    <LogsManagement />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/manage-micro-credit-request'
                element={
                  <AuthorizationRoute>
                    <ManageMicroCredit />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/micro-credit-request-setting'
                element={
                  <AuthorizationRoute>
                    <MicroCreditRequestSetting />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/manage-orders'
                element={
                  <AuthorizationRoute>
                    <ManageOrders />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/wallet-window'
                element={
                  <AuthorizationRoute>
                    <WalletWindow />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path='/change-password'
                element={
                  <ProtectedRoute>
                    <ChangePassword />
                  </ProtectedRoute>
                }
              />

              <Route
                exact
                path='/aml'
                element={
                  <AuthorizationRoute>
                    <Aml />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path='/manage-micro-credit-loan-slabs'
                element={
                  <AuthorizationRoute>
                    <ManageMicroCreditLoanSlabs />
                  </AuthorizationRoute>
                }
              />
            </Route>
            <Route exact path='/' element={<Login />} />
            <Route exact path='/login' element={<Login />} />

            <Route exact path='/forgot-password' element={<ForgotPassword />} />

            <Route
              exact
              path='/reset-password/:resetToken'
              element={<ResetPassword />}
            />
            <Route exact path='*' element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </ToastContextProvider>
    </BrowserRouter>
  )
}

export default App
